export default __webpack_public_path__ + "static/media/hamb.e14d9450.svg";